import {readCookie} from "@tickled-media/web-components.tm-helpers";

export const myIsSet = (obj, key) => {
    if(typeof obj == "undefined") {
        return false;
    }

    const keys = key.split('.');
    if(keys.length == 0) {
        return false;
    }

    for(const i in keys) {
        if(obj != null && obj.hasOwnProperty(keys[i])) {
            obj = obj[keys[i]];
        }
        else {
            return false;
        }
    }

    return true;
}

export const cloneEvent = (e) => {
    if (e===undefined || e===null) return undefined;
    function ClonedEvent() {};
    const clone=new ClonedEvent();
    for (const p in e) {
        const d=Object.getOwnPropertyDescriptor(e, p);
        if (d && (d.get || d.set)) Object.defineProperty(clone, p, d); else clone[p] = e[p];
    }
    Object.setPrototypeOf(clone, e);
    return clone;
}

export const isObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const mobileCheck = () => {
    let check = false;
      if(typeof window != "undefined") {
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      }

   return check;
}

export const offset = (el) =>  {
    if(typeof window != "undefined" && el != null) {
        const rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft,
            viewPortTop: rect.top
        }
    }
    else {
        return false
    }
}

export const gtmSend = (event, category, action, label, value = 1, params={}) => {
    if(typeof window !== "undefined") {
        event = event === 'dynamic' ? 'dynamic event' : event

        if(process.env.REACT_APP_ENV !== 'production') {
            console.log(event, '|', category, '|', action, '|', label, '|', value, '|', params);    
        }
        
        if(process.env.REACT_APP_ENV !== 'development') {
            if(window.dataLayer) {
                const toPush = {
                    event: event,
                    eventValue: value
                };
                if(category) toPush['eventCategory'] = category;
                if(action) toPush['eventAction'] = action;
                if(label) toPush['eventLabel'] = label;

                //params
                for(const k in params) {
                    toPush[k] = params[k];
                }
                //console.log(window.dataLayer, toPush);
                window.dataLayer.push(toPush);
                // This code sends gtm events to native apps
                // The trackWebPageEvent function is defined in the native apps and is used to receive the gtm events
                // if ((window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.trackWebPageEvent) || (window.JSBridge && window.JSBridge.trackWebPageEvent)) {
                //     if(window.JSBridge && window.JSBridge.trackWebPageEvent) {
                //         // send gtm events to Android
                //         window.JSBridge.trackWebPageEvent(JSON.stringify(toPush));
                //     } else {
                //         // send gtm events to iOS
                //         window.webkit.messageHandlers.trackWebPageEvent.postMessage(JSON.stringify(toPush));
                //     }
                // }
            }
        }
    }
}

export const trimEndSlash = (url) => {
    if(url[url.length - 1] == '/') {
        return url.slice(0, -1);
    } else {
        return url;
    }
}

export const esCape = (text) => {
    const tagsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;'
    };
    return text.replace(/[&<>]/g, function(tag) {
        return tagsToReplace[tag] || tag;
    });
}

export const esCapeXSS = text => text.replace(/["<>]/g, '_')

export const copyToClipboard = (str, country) => {

    const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);

    if (isSafari)
    {
        if(typeof country != "undefined")
        {
            switch (country) {
                case 'th':
                    window.prompt("คัดลอกลิงก์ด้วยตนเอง:", str);
                    break;
                case 'id':
                    window.prompt("Salin Tautan Secara Manual:", str);
                    break;
                case 'my':
                    window.prompt("Salin pautan secara manual:", str);
                    break;
                case 'vn':
                    window.prompt("Sao chép liên kết theo cách thủ công:", str);
                    break;
                default:
                    window.prompt("Manually Copy Link:", str);
            }
        }
        else
        {
            window.prompt("Manually Copy Link:", str);
        }
    }
    else
    {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');

        const myAlert = document.createElement('div');
        myAlert.setAttribute("id", "copy-link-prompt")
        myAlert.style.position = 'fixed';
        myAlert.style.bottom = '55px';
        myAlert.style['z-index'] = '5';
        myAlert.style.left = '0';
        myAlert.style.right = '0';
        myAlert.style.display = 'inline-block';
        myAlert.style.margin = '0 auto';
        myAlert.style.width = '160px';
        myAlert.style['text-align'] = 'center';
        myAlert.style.padding = '10px 15px';
        myAlert.style.background = '#3CD295';
        myAlert.style.color = '#fff';
        myAlert.style['border-radius'] = '5px';
        myAlert.style['font-size'] = '14px';
        myAlert.style['z-index'] = '6';
        myAlert.style['font-weight'] = '500';
        myAlert.style['border-radius'] = '8px';

        let t = document.createTextNode("Link Copied");
        if(typeof country != "undefined")
        {
            switch (country) {
                case 'th':
                    t = document.createTextNode("คัดลอกลิงก์แล้ว");
                    break;
                case 'id':
                    t = document.createTextNode("Tautan Disalin");
                    break;
                case 'my':
                    t = document.createTextNode("Pautan Disalin");
                    break;
                case 'vn':
                    t = document.createTextNode("Đã sao chép liên kết");
                    break;
                default:
                    t = document.createTextNode("Link Copied");
            }
        }

        myAlert.appendChild(t);
        document.body.appendChild(myAlert);

        setTimeout(function(){
            document.body.removeChild(myAlert);
        }, 1000);

        document.body.removeChild(el);
    }
}

export const getScrollPostion = () => {
    return window.scrollY || window.pageYOffset || (document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop ? document.documentElement.scrollTop : 0));
}

export const makeRoute = ( url, appReducer ) => {
    let slug = url;
    if(appReducer.locale && url.indexOf('/q/') === -1) {
        const path = url.split('?');
        let vars = [];
        if(path[1]) {
            vars = path[1].split('&').filter(function (el) {
                if(el) {
                    return el
                }
                return false
            });
        }
        const index = vars.indexOf(`lng=${appReducer.locale}`);
        if(index !== -1) {
            vars[index] = `lng=${appReducer.locale}`;
        }
        else {
            vars.push(`lng=${appReducer.locale}`)
        }

        if(vars.length !== 0) {
            slug = path[0] + '?' + vars.join('&');
        }
        slug = slug.replace('?&', '?')
        slug = slug.replace('??', '?')
    }
    
    return slug
}

export const findIndexById = (id, list) => {
    let returnIndex = -1;
    for(const i in list) {
        if(list[i].id == id){
            returnIndex = i;
            break
        }
    }
    return parseInt(returnIndex);
}

export const findTopicIndexById = (id, list) => {
    let returnIndex = -1;
    for(const i in list) {
        if(list[i].topic.id == id){
            returnIndex = i;
            break
        }
    }
    return parseInt(returnIndex);
}

export const findBoothIndexById = (id, list) => {
    let returnIndex = -1;
    for(const i in list) {
        if(list[i].booth.id == id){
            returnIndex = i;
            break
        }
    }
    return parseInt(returnIndex);
}

export const setAdsDefinedSlot = (dfpKeys, device = "", callFrom = "preDefine") => {
    let isSet = true;
    if(device === "mobile" && !mobileCheck()) {
        isSet = false;
    }
    if(device === "desktop" && mobileCheck()) {
        isSet = false;
    }
    
    if(isSet && dfpKeys) {
        //Trigger ad define slot if adScriptStart fn is already called.
        if(typeof window.triggerDefinedSlot !== 'undefined' && typeof window.googletag !== 'undefined' && window.adScriptStartTriggered) {
            window.triggerDefinedSlot(dfpKeys);
            
            if(callFrom === "postDefine" && window.dfpPostDefineKey) {
                window.dfpPostDefineKey.push(dfpKeys)
            }
        }
        else if(window.dfpPreDefineKey){
            window.dfpPreDefineKey.push(dfpKeys)
        }
    }
}

export const getLocalizationI18 = (t) => {
    const mid = new Proxy({}, 
        {
          get: function (target, name) {
            return t(name);
          }
        }
      ); 
    return mid;
}

export const filterTranslation = (locale, translation) => {
    if(locale === 'my'){
        return translation['ms'];
    }else if(locale === 'ph'){
        return translation['fil'];
    }else{
        return translation[locale];
    }
}

export const userDataLayerObject = (user = {}, oldUserDetails, updatedUserDetails) => {
    const { is_pregnant, num_kids, tracker_info = {}, working_status, education_level, language, country, marital_status, gender, id, birthdate, isDataSharingEnabled } = user;
    return {
        user_id: id || 0,
        user_gender: gender || '--',
        user_age: birthdate ? calculateAge(birthdate) : 0,
        user_marital_status: marital_status || '--',
        user_country: country || '--',
        user_language: language || '--',
        user_highest_education: education_level || '--',
        user_working_status: working_status || '--',
        // user_prim_email_verified: 0, // we don't have this data
        // user_prim_mob_verified: 0, // we don't have this data
        user_due_date: is_pregnant && tracker_info.due_date || '--',
        // user_monthly_income: 0, // we don't have this data
        // user_monthly_expenditure: 0, // we don't have this data
        data_sharing_consent: isDataSharingEnabled,
        // user_stage: user_stage || '', // getting null from BE
        // user_stage_number: user_stage_number || 0, // getting null from BE
        num_kids: num_kids || 0,
        is_pregnant,
        action_detail: profileUpdateDetails(oldUserDetails, updatedUserDetails)
    }
}

// mey reducer ka data aayaga
export const profileUpdateDetails = (oldUserDetails = {}, updatedUserDetails = {}) => {
    const workingStatus = oldUserDetails.working_status === updatedUserDetails.working_status ? "N" : "Y";
    const educationLevel = oldUserDetails.education_level === updatedUserDetails.education ? "N" : "Y";
    const language = oldUserDetails.language === updatedUserDetails.langCode ? "N" : "Y";
    const country = oldUserDetails.country === updatedUserDetails.country ? "N" : "Y";
    const address = oldUserDetails.address === updatedUserDetails.address ? "N" : "Y";
    const phone1 = oldUserDetails.phone === updatedUserDetails.phone ? "N" : "Y";
    const email2 = (oldUserDetails.secondary_email || '') === updatedUserDetails.email ? "N" : "Y";
    const maritalStatus = oldUserDetails.marital_status === updatedUserDetails.marital_status ? "N" : "Y";
    const dob = oldUserDetails.birthdate === updatedUserDetails.dob ? "N" : "Y";
    const gender = oldUserDetails.gender === updatedUserDetails.gender ? "N" : "Y";
    const bio = (oldUserDetails.tagline || '') === updatedUserDetails.tagline ? "N" : "Y";
    const name = oldUserDetails.fullname === updatedUserDetails.fullname ? "N" : "Y";
    const pic = oldUserDetails.image === updatedUserDetails.defaultImage && !updatedUserDetails.ifImageUploaded && !updatedUserDetails.ifImageDeleted ? "N" : "Y";

    return `Pic:${pic}|Name:${name}|Bio:${bio}|Gen:${gender}|DoB:${dob}|MS:${maritalStatus}|E2:${email2}|P1:${phone1}|Ads:${address}|Con:${country}|Lan:${language}|Edu:${educationLevel}|WS:${workingStatus}`
}

export const calculateAge = (birthday) => {
    const birthDate = new Date(birthday);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export const getWpCommerceSiteKey = (country) => {
    const countryCode_wpCommerceSiteKey = {
        sg: "sg",
        id: "id",
        th: "th",
    }
    return countryCode_wpCommerceSiteKey[country]
}

export const getCartKey = (country) => {
    let cartKey = ''
    const tmcartKey = readCookie('tmCartKey') || '';
    if(tmcartKey) {
        const cartKeyArr = tmcartKey.split('-'); //split cart key and WpCommerceSiteKey
        if(cartKeyArr.length === 2) {
            const wpCommerceSiteKey = getWpCommerceSiteKey(country)
            if(cartKeyArr[0] === wpCommerceSiteKey) {
                cartKey = cartKeyArr[1]
            }
        }
    }
    return cartKey;
}

export const getNetcoreSiteId = (siteConfigKey = 'sg') => {
    let netcoreSiteIds_siteConfigKey = {}
    if(process.env.REACT_APP_ENV === 'production') {
        netcoreSiteIds_siteConfigKey = {
            "sg": "f5a14106df554eb110639971bca958d8",
            "id": "059b9283984932841f1ec4962678b2c7",
            "th": "1ec4e6390e1eca26508ed97504e968f1",
            "my": "aa6c43a1d7027733830dafbbf6184cab",
            "ph": "bbea3ab3730d3e19d2c2c2f5911870c0",
            "vn": "83bd7308c845fcf3d4ffe80c58eb497e",
        }
    }
    else {
        netcoreSiteIds_siteConfigKey = {
            "sg": "90513e6ef25b1ed98ea867c926cef1a6",
            "id": "14eecc752a0f56b212df9ee0bb5bbbf7",
            "th": "826a9998a409f7bbf00adaef9ddd94f6",
            "my": "5cd07671931160b8720c919224ab74b4",
            "ph": "f226ace5d96ec9e057d30dd6e1c0e419",
            "vn": "295b20cf47e11c3d1f3ef97280522e7d",
        }
    }

    return netcoreSiteIds_siteConfigKey[siteConfigKey] || '';
}

export const transformFollowersCount = (followersCount = 0, lng = 'en') => {
    const abbreviations = {
        en: { thousand: 'K', million: 'M', billion: 'B', following: 'following' },
        id: { thousand: 'Ribu', million: 'Juta', billion: 'Miliar', following: 'mengikuti' },
        th: { thousand: 'พัน', million: 'ล้าน', billion: 'พันล้าน', following: 'กำลังติดตาม' },
        my: { thousand: 'Ribu', million: 'Juta', billion: 'Bilion', following: 'mengikuti' },
        ph: { thousand: 'K', million: 'M', billion: 'B', following: 'pina-follow' }
    };

    const { thousand, million, billion, following } = abbreviations[lng] || abbreviations['en'];
    const space = lng === 'en' || lng === 'ph' ? '' : ' ';

    if (followersCount >= 1e9) {
        return `${(followersCount / 1e9).toFixed(1).replace(/\.0$/, '')}${space}${billion} ${following}`;
    } else if (followersCount >= 1e6) {
        return `${(followersCount / 1e6).toFixed(1).replace(/\.0$/, '')}${space}${million} ${following}`;
    } else if (followersCount >= 1e3) {
        return `${(followersCount / 1e3).toFixed(1).replace(/\.0$/, '')}${space}${thousand} ${following}`;
    }
    return followersCount;
};

export const getQueryParam = (location, name) => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(name);
}
